// src/pages/AdminMealPage.js

import React, { useState } from 'react';
import { Container, Typography, Button, Divider } from '@mui/material';
import MealList from '../components/MealList';
import MealForm from '../components/MealForm';
import { useDispatch } from 'react-redux';
import { addMeal, updateMeal, deleteMeal } from '../actions/mealActions';

const AdminMealPage = () => {
  const dispatch = useDispatch();
  const [openMealForm, setOpenMealForm] = useState(false);
  const [currentMeal, setCurrentMeal] = useState(null);

  const handleAddMeal = () => {
    setCurrentMeal(null);
    setOpenMealForm(true);
  };

  const handleEditMeal = (meal) => {
    setCurrentMeal(meal);
    setOpenMealForm(true);
  };

  const handleMealSubmit = (mealData) => {
    if (currentMeal) {
      dispatch(updateMeal(currentMeal.meal_id, mealData))
        .then(() => {
          setOpenMealForm(false);
          setCurrentMeal(null);
        })
        .catch((error) => {
          console.error('Error updating meal:', error);
        });
    } else {
      dispatch(addMeal(mealData))
        .then(() => {
          setOpenMealForm(false);
        })
        .catch((error) => {
          console.error('Error adding meal:', error);
        });
    }
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Admin - Meal Management
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleAddMeal}
        style={{ marginBottom: '16px' }}
      >
        Add Meal
      </Button>
      <Divider style={{ margin: '20px 0' }} />
      <MealList onEdit={handleEditMeal} />
      <MealForm
        open={openMealForm}
        onClose={() => setOpenMealForm(false)}
        onSubmit={handleMealSubmit}
        meal={currentMeal}
      />
    </Container>
  );
};

export default AdminMealPage;
